<template>
  <div class="admin-page">
    <h2 class="page-title">提现审核与导出</h2>
    <div class="admin-toolbar">
      <el-select v-model="filters.status" placeholder="状态" clearable @change="fetchList">
        <el-option label="待审核" value="pending" />
        <el-option label="已通过待打款" value="approved" />
        <el-option label="已打款" value="paid" />
        <el-option label="已拒绝" value="rejected" />
      </el-select>
      <el-button type="primary" @click="fetchList">查询</el-button>
      <el-button type="success" @click="exportCsv">导出待打款 CSV</el-button>
    </div>
    <el-table :data="items" v-loading="loading" border>
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column prop="userId" label="用户ID" width="90" />
      <el-table-column label="金额（元）" width="100">
        <template #default="s">{{ (s.row.amountCents / 100).toFixed(2) }}</template>
      </el-table-column>
      <el-table-column prop="bankName" label="银行" width="120" />
      <el-table-column prop="accountName" label="户名" width="100" />
      <el-table-column prop="status" label="状态" width="120">
        <template #default="s">{{ statusLabel(s.row.status) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="240" fixed="right">
        <template #default="s">
          <el-button v-if="s.row.status === 'pending'" link type="success" @click="review(s.row, 'approve')">通过</el-button>
          <el-button v-if="s.row.status === 'approved'" link type="primary" @click="markPaid(s.row)">标记已打款</el-button>
          <el-button v-if="s.row.status === 'pending'" link type="danger" @click="openReject(s.row)">拒绝</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog v-model="rejectVisible" title="拒绝提现申请" width="560px">
      <AdminRejectReasonField
        v-model="rejectReply"
        category="withdraw"
        :rows="3"
        placeholder="拒绝原因（用户会收到站内信）；可点选上方常见原因"
      />
      <template #footer>
        <el-button @click="rejectVisible = false">取消</el-button>
        <el-button type="danger" :loading="processing" @click="confirmReject">确认拒绝</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  fetchAdminWithdrawApplications,
  reviewWithdrawApplication,
  adminWithdrawExportUrl,
  WITHDRAW_STATUS_LABELS
} from '@/utils/userHub'
import AdminRejectReasonField from '@/components/AdminRejectReasonField.vue'

export default {
  name: 'AdminWithdrawManagement',
  components: { AdminRejectReasonField },
  data() {
    return {
      loading: false,
      processing: false,
      items: [],
      filters: { status: 'pending' },
      rejectVisible: false,
      rejectReply: '',
      currentRow: null
    }
  },
  created() {
    const status = this.$route.query.status
    if (typeof status === 'string' && status) {
      this.filters.status = status
    }
    this.fetchList()
  },
  methods: {
    statusLabel(s) {
      return WITHDRAW_STATUS_LABELS[s] || s
    },
    async fetchList() {
      this.loading = true
      try {
        const data = await fetchAdminWithdrawApplications({
          page: 1,
          pageSize: 100,
          status: this.filters.status || undefined
        })
        this.items = data.items || []
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    async review(row, action, adminReply = '') {
      this.processing = true
      try {
        await reviewWithdrawApplication({ applicationId: row.id, action, adminReply })
        this.$message.success('处理成功')
        this.fetchList()
      } catch (e) {
        this.$message.error(e.message || '处理失败')
      } finally {
        this.processing = false
      }
    },
    openReject(row) {
      this.currentRow = row
      this.rejectReply = ''
      this.rejectVisible = true
    },
    confirmReject() {
      if (!this.rejectReply.trim()) {
        this.$message.warning('请填写拒绝原因')
        return
      }
      this.review(this.currentRow, 'reject', this.rejectReply.trim())
      this.rejectVisible = false
    },
    async markPaid(row) {
      const batchNo = `B${Date.now()}`
      try {
        await reviewWithdrawApplication({
          applicationId: row.id,
          action: 'paid',
          batchNo
        })
        this.$message.success('已标记打款')
        this.fetchList()
      } catch (e) {
        this.$message.error(e.message || '操作失败')
      }
    },
    exportCsv() {
      const url = adminWithdrawExportUrl()
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.page-title { margin: 0 0 16px; }
.admin-toolbar { display: flex; flex-wrap: wrap; gap: 12px; margin-bottom: 16px; }
</style>
